import { render, staticRenderFns } from "./TickerAdminEditService.vue?vue&type=template&id=dd17b78c"
import script from "./TickerAdminEditService.vue?vue&type=script&lang=js"
export * from "./TickerAdminEditService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports